/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assign_VenueInputs */

const th_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนาม`)
};

const en_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue`)
};

const ja_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会場`)
};

const zh_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场馆`)
};

const es_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pabellón`)
};

const pt_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginásio`)
};

const id_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat`)
};

const fr_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salle`)
};

const tl_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue`)
};

const vi_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa điểm`)
};

const ko_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기장`)
};

const de_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halle`)
};

const ru_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Площадка`)
};

const tr_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salon`)
};

const it_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impianto`)
};

const pl_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hala`)
};

const uk_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майданчик`)
};

const hi_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थल`)
};

const ar_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصالة`)
};

const ms_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat`)
};

const bn_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাঠ`)
};

const zh_tw2_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場館`)
};

const zh_hk2_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場館`)
};

const ur_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقام`)
};

const fa_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سالن`)
};

const sw_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukumbi`)
};

const nl_assign_venue = /** @type {(inputs: Assign_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaal`)
};

/**
* | output |
* | --- |
* | "Venue" |
*
* @param {Assign_VenueInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const assign_venue = /** @type {((inputs?: Assign_VenueInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assign_VenueInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_assign_venue(inputs)
	if (locale === "ja") return ja_assign_venue(inputs)
	if (locale === "zh") return zh_assign_venue(inputs)
	if (locale === "es") return es_assign_venue(inputs)
	if (locale === "pt") return pt_assign_venue(inputs)
	if (locale === "id") return id_assign_venue(inputs)
	if (locale === "fr") return fr_assign_venue(inputs)
	if (locale === "tl") return tl_assign_venue(inputs)
	if (locale === "vi") return vi_assign_venue(inputs)
	if (locale === "ko") return ko_assign_venue(inputs)
	if (locale === "de") return de_assign_venue(inputs)
	if (locale === "ru") return ru_assign_venue(inputs)
	if (locale === "tr") return tr_assign_venue(inputs)
	if (locale === "it") return it_assign_venue(inputs)
	if (locale === "pl") return pl_assign_venue(inputs)
	if (locale === "uk") return uk_assign_venue(inputs)
	if (locale === "hi") return hi_assign_venue(inputs)
	if (locale === "ar") return ar_assign_venue(inputs)
	if (locale === "ms") return ms_assign_venue(inputs)
	if (locale === "bn") return bn_assign_venue(inputs)
	if (locale === "zh-TW") return zh_tw2_assign_venue(inputs)
	if (locale === "zh-HK") return zh_hk2_assign_venue(inputs)
	if (locale === "ur") return ur_assign_venue(inputs)
	if (locale === "fa") return fa_assign_venue(inputs)
	if (locale === "sw") return sw_assign_venue(inputs)
	if (locale === "nl") return nl_assign_venue(inputs)
	return en_assign_venue(inputs)
});